(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueAccountDeleteController',QueueAccountDeleteController);

    QueueAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'QueueAccount'];

    function QueueAccountDeleteController($uibModalInstance, entity, QueueAccount) {
        var vm = this;

        vm.queueAccount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            QueueAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
